import { ReactElement } from 'react';
import Skeleton from 'react-loading-skeleton';
import { HistoryCardLoading as HistoryCardLoadingStyled } from './styles';

export function HistoryCardLoading(): ReactElement {
  return (
    <HistoryCardLoadingStyled>
      <Skeleton
        height="372px"
        borderRadius="8px"
        className="skeleton-span"
        containerClassName="skeleton-container-span"
      />
    </HistoryCardLoadingStyled>
  );
}
